// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBz8D3slvBXg6sIfpl9wW6W2t01ibFfyJs",
  authDomain: "bellcorp-expense-tracker.firebaseapp.com",
  projectId: "bellcorp-expense-tracker",
  storageBucket: "bellcorp-expense-tracker.firebasestorage.app",
  messagingSenderId: "10440805108",
  appId: "1:10440805108:web:884a86857285d8b21faca1",
  measurementId: "G-LRNQR1KV0P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);